import React, {Fragment, useState} from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import Collapse from '@material-ui/core/Collapse';

import AppButton from './AppButton';
import PhoneInput from 'react-phone-input-2';
import api from '../services/api';
import Text from './fields/Text';
import {isStringEmpty} from '../util/value';
import {addNotification} from '../redux/actions';
import {useDispatch} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  icon: (props) => ({
    height: 'min-content',
    transform: props.open ? 'rotate(90deg)' : 'rotate(0deg)',
    transition: 'all 200ms cubic-bezier(0.000, 0.000, 0.580, 1.000)',
  }),
}));

const UserItem = ({disableDivider, owner, source, onEdit, onRemove, onApprove}) => {
  const [value, setValue] = useState(source);
  const [open, setOpen] = useState(false);
  const classes = useStyles({open});
  const dispatch = useDispatch();

  function handleEdit() {
    const fieldRequired = ['first_name', 'last_name', 'email', 'phone_country_code', 'phone', 'dni'];

    for (let i = fieldRequired.length - 1; i >= 0; i--) {
      if (isStringEmpty(value[fieldRequired[i]])) {
        dispatch(addNotification(`El campo "${fieldRequired[i]}" es requerido.`, 'error'));
        return;
      }
    }
    api.users
      .patch(source.id, {
        first_name: value.first_name,
        last_name: value.last_name,
        email: value.email,
        phone_country_code: value.phone_country_code,
        phone: value.phone,
        dni: value.dni,
      })
      .then((it) => {
        if (onEdit) {
          onEdit(it);
        }
        setOpen(false);
      });
  }

  const toggleEdit = () => {
    setOpen((value) => !value);
  };

  return (
    <Fragment>
      <Box display="flex" justifyContent="space-between" my={2}>
        <Box display="flex" alignItems="center" mt={2} mb={2}>
          <Box ml={1}>
            <Typography variant="subtitle1">
              {source.first_name} {source.last_name}
            </Typography>
            <Typography color="primary" variant="subtitle2">
              {source.owner_company === 'true' ? 'Administrador' : 'Usuario'}
            </Typography>
          </Box>
        </Box>
        <IconButton aria-label="expand" className={classes.icon} onClick={toggleEdit}>
          <ArrowForwardIosIcon fontSize="large" />
        </IconButton>
      </Box>
      <Collapse in={open}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Text
              name={'first_name'}
              label="Nombre"
              value={value.first_name}
              onChange={(e) => {
                setValue({...value, first_name: e.target.value});
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Text
              name={'last_name'}
              label="Apellido"
              value={value.last_name}
              onChange={(e) => {
                setValue({...value, last_name: e.target.value});
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Text
              name={'email'}
              label="Correo electrónico"
              value={value.email}
              onChange={(e) => {
                setValue({...value, email: e.target.value});
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <PhoneInput
              masks={{co: '(...) ... ....'}}
              specialLabel={''}
              value={`${value.phone_country_code}${value.phone}`}
              country={value.phone_country_code}
              name="phone"
              inputStyle={{
                width: '100%',
                border: '1px solid #e2e2e1',
                backgroundColor: '#fcfcfb',
                height: 58,
              }}
              containerStyle={{
                width: '100%',
              }}
              onChange={(phone, {dialCode: phone_country_code}) => {
                setValue({
                  ...value,
                  phone: phone.substr(phone_country_code.length),
                  phone_country_code,
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Text
              name={'dni'}
              label="Cedula"
              value={value.dni}
              onChange={(e) => {
                setValue({...value, dni: e.target.value});
              }}
            />
          </Grid>
        </Grid>
        {owner && (
          <Box mt={4} mb={3}>
            <Grid item xs={12} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <AppButton
                round
                variant="contained"
                color="primary"
                onClick={() => {
                  handleEdit();
                }}
              >
                Guardar
              </AppButton>
              &nbsp;
              <AppButton
                round
                variant="contained"
                color="secondary"
                style={{marginRight: 10}}
                onClick={() => (onRemove ? onRemove(source.id) : null)}
              >
                Eliminar
              </AppButton>
              {source.status === 'pending security verification' && (
                <AppButton
                  round
                  variant="contained"
                  color="secondary"
                  onClick={() => (onApprove ? onApprove(source.id) : null)}
                >
                  Aprobar usuario
                </AppButton>
              )}
            </Grid>
          </Box>
        )}
      </Collapse>
      {!disableDivider && <Divider />}
    </Fragment>
  );
};

export default UserItem;
